// extracted by mini-css-extract-plugin
export default {"Stwelfth":"Stwelfth_Stwelfth__0V8Fu","wrap":"Stwelfth_wrap__PcYzy","title":"Stwelfth_title__QND2E","wrap_en":"Stwelfth_wrap_en__L63vG","desc":"Stwelfth_desc__-M4nZ"};